module.exports = __webpack_public_path__ + "static/media/schedule_structure_include_in_match.f704b047.mov";